// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"358":"d7287362","366":"1c66765c","450":"c1b4d5ec","480":"fcefe031","489":"36f0789d"}[chunkId] + ".chunk.css";
};